import Nullstack from 'nullstack';
export default function IconRun({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-run",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("circle", {
    cx: "13",
    cy: "4",
    r: "1"
  }), "   ", Nullstack.element("path", {
    d: "M4 17l5 1l.75 -1.5"
  }), "   ", Nullstack.element("path", {
    d: "M15 21l0 -4l-4 -3l1 -6"
  }), "   ", Nullstack.element("path", {
    d: "M7 12l0 -3l5 -1l3 3l3 1"
  }), " ");
}